import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BusinessInfoWrapper = styled.div`
  display: grid;
  row-gap: ${Spacing.S16};
  column-gap: ${Spacing.S12};
  grid-template-columns: repeat(3, 1fr);
`
